import icon from "images/layout/chevron-up.svg"
import parse from "html-react-parser"

export default function ChevronUpIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
